module.exports = __webpack_public_path__ + "static/img/floor1-lz2.6725c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-lz2.png
// module id = IOU3
// module chunks = 1